<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <g id="Download">
      <path
        id="Rectangle 1"
        d="M20 8.49268L12 16.4927L4 8.49267"
        stroke="#F04E23"
        stroke-width="3"
      />
      <path id="Vector 1" d="M12 16L12 2" stroke="#F04E23" stroke-width="3" />
      <path
        id="Vector 2"
        d="M2 21.5L22 21.5"
        stroke="#F04E23"
        stroke-width="3"
      />
    </g>
  </svg>
</template>

<script lang="ts" setup></script>
